<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
    max-width="70vW"
  >
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        Historial OP's surtidas
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-data-table
                fixed-header
                height="auto"
                :headers="headers"
                :items="orderProductHistory"
                :items-per-page="10"
                no-data-text="No hay historial"
                loading-text="Cargando historial..."
                :page.sync="page"
                hide-default-footer
                :loading="fetchingData"
                @click:row="rowSelect"
                :item-class="row_classes"
              >
                <template #[`item.presentation`]="{ item }">
                  {{ item.presentation.name }}
                </template>
                <template #[`item.action`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="red"
                        @click="deleteDelivery(item)"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="item.status != 'ASSIGNED'"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Revertir acción</span>
                  </v-tooltip>
                </template>
                <template #[`item.lotes`]="{ item }">
                  <div v-for="(lote, index) of item.lotes" :key="index">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ lote.loteId }}
                        </span>
                      </template>
                      <span>Piezas utilizadas: {{ lote.doses }}</span>
                    </v-tooltip>

                    <v-divider></v-divider>
                  </div>
                </template>
                <template #[`item.createdAt`]="{ item }">
                  {{ dateFormat(item.createdAt) }}
                </template>
              </v-data-table>
              <v-pagination
                v-model="page"
                :length="numPages"
                total-visible="10"
                color="primary"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="red" block @click="closeModal()" dark>Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations } from "vuex";
//axios
import axios from "axios";
// date library
import dayjs from "dayjs";
export default {
  data: () => ({
    orderProductHistory: [],
    fetchingData: false,
    headers: [
      {
        text: "OP-Entrega",
        align: "center",
        value: "serial",
        sortable: false,
      },
      {
        text: "Producto",
        align: "center",
        value: "name",
        sortable: false,
      },
      {
        text: "Presentación",
        align: "center",
        value: "presentation",
        sortable: false,
      },
      {
        text: "Piezas requeridas",
        align: "center",
        value: "qty",
        sortable: false,
      },

      { text: "Acción", align: "center", value: "action", sortable: false },
      {
        text: "Lotes",
        align: "center",
        value: "lotes",
        sortable: false,
      },
      {
        text: "Fecha de surtido",
        align: "center",
        value: "createdAt",
        sortable: false,
      },
    ],
    page: 1,
    numPages: 1,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    ...mapActions("order", ["getProducts", "removeAllStockFromProduct"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    async fetchData() {
      try {
        this.fetchingData = true;
        let response = await this.getProducts({
          filters: {
            status: ["ASSIGNED", "SUPPLIED"],
          },
          page: this.page,
        });
        if (response) {
          if (!response.error) {
            this.orderProductHistory = response.productOps;
            this.numPages = response.pages;
          } else {
            this.$swal({
              icon: "error",
              text: "Algo salio mal al cargar historial!!",
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            text: "Algo salio mal al cargar historial!!",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar historial",
          timeout: 3500,
        });
      }
      this.fetchingData = false;
    },

    closeModal() {
      this.show = false;
    },
    rowSelect(rowValue) {
      this.orderProductHistory = this.orderProductHistory.map((data) => {
        if (rowValue._id == data._id) {
          data.clicked = true;
        } else {
          data.clicked = false;
        }
        return data;
      });
    },
    row_classes(value) {
      if (value.clicked) {
        return "custom-highlight-row";
      }
    },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    async deleteDelivery(item) {
      try {
        let payload = {
          productId: item._id,
        };
        let response = await this.removeAllStockFromProduct(payload);
        if (!response) throw response;
        this.page = 1;
        this.$swal({
          icon: "success",
          text: "Evento revertiddo exitosamente",
          showConfirmButton: false,
          timer: 2000,
        });
        await this.fetchData();
        console.log("FETCH");
        this.$emit("fetchData");
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al eliminar evento",
          timeout: 3500,
        });
      }
    },
  },
  watch: {
    async page() {
      await this.fetchData();
    },
  },
};
</script>
